import { testRideAction } from "./action"

const initialState = {
  testrideBooked: false,
}

export function testRideReducer(state = initialState, action) {
  switch (action.type) {
    case testRideAction.SET_TESTRIDE_DATA: {
      return Object.assign({}, state, action.payload)
    }
    default:
      return state
  }
}
